import React from "react";
import BreadCumb from "../component/BreadCumb";
import GalleryCard from "../component/GalleryCard";
import {Helmet} from "react-helmet-async";

const Gallery = () => {
    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Meet With Our Teams</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/gallery`}/>
            </Helmet>
            <main className="main">
                <BreadCumb image="gallery.webp" />
                <GalleryCard />
            </main>
        </>
    );
}

export default Gallery;